import React, { useEffect, useState } from 'react';
import { useNavigate, useParams, useSearchParams } from 'react-router-dom';
import { observer } from 'mobx-react';
import { TextDefault } from '@awarego-ui/components';
import ThemedSpinner from '../../components/themed/ThemedSpinner';
import services from '../../services';
import { useStores } from '../../hooks/use-stores';

/**
 * Opens `/trainings/join/:uniqKey?o=companyId` after sign-in; enrolls the user on
 * the training's hidden on-demand list then opens the training view.
 */
function TrainingJoinByUniqKey({ companyId }) {
    const { uniqKey } = useParams();
    const [searchParams] = useSearchParams();
    const navigate = useNavigate();
    const { commonStore } = useStores();
    const [error, setError] = useState(null);
    const o = searchParams.get('o');
    const cid =
        o != null && o !== '' && !Number.isNaN(Number(o)) ? Number(o) : companyId;

    useEffect(() => {
        let cancelled = false;
        (async () => {
            try {
                const out = await services.Companies.automationsService(
                    cid
                ).enrollByTrainingUniqKey(uniqKey);
                if (cancelled) return;
                navigate(`/trainings/${out.trainingId}/view`, {
                    replace: true,
                });
            } catch (e) {
                if (!cancelled) {
                    const msg = e.message || String(e);
                    setError(msg);
                    commonStore.showMessage(msg, 'error');
                }
            }
        })();
        return () => {
            cancelled = true;
        };
    }, [cid, uniqKey, navigate, commonStore]);

    if (error) {
        return (
            <div style={{ padding: 24 }}>
                <TextDefault>
                    Could not join from this link. Confirm you are signed in to the
                    correct organization and that the link is still valid.
                </TextDefault>
            </div>
        );
    }

    return (
        <div style={{ padding: 48, textAlign: 'center' }}>
            <ThemedSpinner />
            <TextDefault lighter style={{ marginTop: 16, display: 'block' }}>
                Joining training…
            </TextDefault>
        </div>
    );
}

export default observer(TrainingJoinByUniqKey);
